import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";


export const addOrUpdateShiftRoster = async (shiftData, editRosterID) => {
    try {
        const payload = {
            p_id_shift_roaster: editRosterID || 0,
            p_id_shift: shiftData.selectedRShiftCodeID,
            p_id_department: shiftData.selectedDepartementID,
            p_start_date: shiftData.startDate,
            p_end_date: shiftData.endDate,
            p_Location: shiftData.location?.trim() || '',
            p_created_by: localStorage.getItem('userID') || 'Unknown',
            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        const endpoint = editRosterID === 0
            ? API_ENDPOINTS.HR_SHIFT_ROASTER_MASTER_ADD
            : API_ENDPOINTS.HR_SHIFT_ROASTER_MASTER_UPDATE;

        return await callApi(endpoint, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};


export const loadShiftRoster = async () => {
    try {
        const payload = {

            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.HR_SHIFT_ROASTER_MASTER_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadShiftEmployeeAssignment = async (payload) => {
    try {
        // const payload = {
        //     p_companyid: localStorage.getItem('companyid') || 0,
        //     p_plantid: 1,
        // };

        return await callApi(API_ENDPOINTS.HR_SHIFT_EMPLOYEE_ASSIGNMENT_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }

};

export const loadShiftAssignedEmployeesList = async (payload) => {
    try {   
        return await callApi(API_ENDPOINTS.HR_SHIFT_ASSIGNED_EMPLOYEES_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading shift assiged employees list:", error);
        throw error;
    }

};

export const loadShifRosterListByDepartmentID = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.HR_SHIFT_EMPLOYEE_ASSIGNMENT_ROASTER_MASTER_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const loadShifRosterEmployeeListByDepartmentID = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.HR_SHIFT_EMPLOYEE_LIST_BY_DEPARTMENT, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const loadShifAssignmentStatus = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.HR_SHIFT_EMPLOYEE_ASSIGNMENT_STATUS, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

// load shift code

export const loadShiftCode=async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}


// break type
export const loadShiftMasterBreakType=async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_BREAK_TYPE, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

// shift-code
export const checkShiftCodeStatus=async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE_STATUS, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

// load shift master list
export const shiftMasterList=async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.HR_SHIFT_MASTER_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

// load shift detail

export const loadSelectedShiftDetail=async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.HR_SHIFT_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}
